export const customVirtualBackgroundKeys = {
  all: () => ['CUSTOM_VIRTUAL_BACKGROUND'] as const,
};
